import "bootstrap";
import Headroom from "headroom.js";
import "./components/cookie-consent";
import "./components/isotope-filter";
import "./components/structure-filter";
import "./components/tilaratkaisut-components-filter";
import "./react";
import "./ga4";

import ElementQueries from "css-element-queries/src/ElementQueries";

ElementQueries.listen();

/* global _ */
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  let menuOnTop = true;
  let menuVisible = true;
  let menuOpaque = false;
  let prevScroll = 0;
  const config = {
    menuScrollTreshold: 0,
  };
  const $navPrimary = $(".nav-primary");
  const $html = $("html");
  const $htmlAndBody = $("html, body");
  let $searchResults = $("#addsearch-results");
  const $searchDropdown = $(".js-muotolevy-search-dropdown");
  const $dynamicNav = $(".wp-block-kehittamo-block-dynamic-nav");
  const $singlePost = $("body.single-post");
  let $slickNoDesktop = $();
  // Try to find the breadcrumb block
  const headroomHeader = document.querySelector(
    ".wp-block-boldblocks-breadcrumb-block",
  );
  // If it's found, initialize Headroom
  if (headroomHeader) {
    const headroom = new Headroom(headroomHeader);
    headroom.init();
  }

  /**
   * Megamenu styles depend on dynamic navigation
   * so check if it's found and only then give padding
   */
  function addPaddingBody() {
    if ($dynamicNav.length > 0 || $singlePost.length) {
      // $('header.banner').css('background-color', '#FFF');
      $("header.banner").addClass("active-color");
      // $('body').css('padding-top', '5rem');
      $("body").addClass("body-padding");
    }
  }
  addPaddingBody();

  function handleScroll() {
    const scroll = $(window).scrollTop();

    if (scroll >= config.menuScrollTreshold) {
      // Not on top
      if (menuOnTop === true) {
        menuOnTop = false;
        $("header.banner").removeClass("ontop");
        if ($(".wp-block-kehittamo-block-dynamic-nav")) {
          $(".wp-block-kehittamo-block-dynamic-nav").removeClass("ontop");
        }
      }
    } else {
      // On top
      if (menuOnTop === false) {
        menuOnTop = true;
        $("header.banner").addClass("ontop");
        if ($(".wp-block-kehittamo-block-dynamic-nav")) {
          $(".wp-block-kehittamo-block-dynamic-nav").addClass("ontop");
        }
      }
    }

    if (scroll < config.menuScrollTreshold) {
      if (menuOpaque === true) {
        menuOpaque = false;
        $("header.banner").removeClass("low");
        $searchDropdown.removeClass("low");
        $(".wp-block-kehittamo-block-dynamic-nav").removeClass("low");
      }
    } else if (menuOpaque === false) {
      menuOpaque = true;
      $("header.banner").addClass("low");
      $searchDropdown.addClass("low");
      $(".wp-block-kehittamo-block-dynamic-nav").addClass("low");
    }

    // Scroll down
    if (scroll > prevScroll) {
      if (menuVisible === true) {
        $("header.banner").removeClass("visible");
        menuVisible = false;
      }
    }

    // Scroll up
    if (scroll < prevScroll) {
      if (menuVisible === false) {
        $("header.banner").addClass("visible");
        menuVisible = true;
      }
    }
    prevScroll = scroll;

    // Refresh search results window position (for fixed version).
    $searchResults = $searchResults.length
      ? $searchResults
      : $("#addsearch-results");
    if ($searchResults.length && $searchResults.is(":visible")) {
      window.addsearch.showResults();
    }
    // Fix slight issue when scrolling fast to top.
    if (!scroll) {
      setTimeout(() => {
        if ($searchResults.length && $searchResults.is(":visible")) {
          window.addsearch.showResults();
        }
      }, 100);
    }
  }

  // Set mobile menu height.
  function setMobileMenuHeight() {
    const $navPrimary = $(".nav-primary");
    const $header = $("header.banner");
    const navHeight = $(window).height() - $header.outerHeight();

    $navPrimary.height(navHeight);
  }

  /**
   * Scroll (and focus) to target search input.
   *
   * @param  {jQuery}  $input       The input we are scrolling to.
   * @param  {boolean} focus        True if we want to focus on input.
   */
  function scrollToSearchInput($input, focus) {
    const scrollTop = $input.offset().top - 128;
    const scrollDifference = Math.abs(scrollTop - $(window).scrollTop());
    // If within 10px of the desired spot, no need to scroll.
    if (scrollDifference > 10) {
      $htmlAndBody.animate(
        {
          scrollTop,
        },
        500,
        "swing",
        focus &&
          (() => {
            $input.focus();
          }),
      );
    } else if (focus) {
      $input.focus();
      // Fire a search if search field has text in it.
      if ($input.val()) {
        setTimeout(() => {
          // Speech bubble action.
          $input.trigger("keyup");
        }, 0);
      }
    }
  }

  /**
   * Initialize all search-related functionality.
   */
  function initSearch() {
    // Search-related variables 'cached', some are at the top of this file.
    const $searchHeader = $(".js-muotolevy-search-header");
    const $searchDropdown = $(".js-muotolevy-search-dropdown");
    const $searchDropdownInput = $searchDropdown.find(
      ".js-muotolevy-search-input",
    );
    const $searchInput = $(".js-muotolevy-search-input");
    const $searchButton = $(".js-muotolevy-search-button");

    /**
     * When clicking on the header search icon: if dropdown exists, toggle
     * it's visibility, else scroll to first search field.
     */
    $searchHeader.click((e) => {
      if ($searchDropdown.length) {
        e.preventDefault();
        $searchDropdown.slideToggle(200, () => {
          if ($searchDropdown.is(":visible")) {
            $searchDropdownInput.focus();
            // Fire a search if search field has text in it.
            if ($searchDropdownInput.val()) {
              setTimeout(() => {
                $searchDropdownInput.trigger("keyup");
              }, 0);
            }
          }
          // set $searchDropdown top to $('.js-header-container').height() to avoid overlapping with header.
          $searchDropdown.css({
            top: $(".js-header-container").height(),
          });
        });
      } else if ($searchInput.length) {
        e.preventDefault();
        scrollToSearchInput($searchInput, true);
      }
      // If something goes wrong, go to search page.
    });

    /**
     * When clicking any search input except the one inside dropdown,
     * scroll to it.
     */
    $searchInput.click(function (e) {
      e.preventDefault();
      const $this = $(this);
      if (!$this.is($searchDropdownInput)) {
        // Hide search dropdown if clicking on an other input.
        $searchDropdown.slideUp(200);
        scrollToSearchInput($this);
      }
    });

    /**
     * Focus and scroll to search input if a nearby search button
     * is pressed.
     */
    $searchButton.click(function (e) {
      e.preventDefault();
      const $input = $(this.parentNode.parentNode).find(
        ".js-muotolevy-search-input",
      );
      const $isDropdownInput = $input.is($searchDropdownInput);

      // Hide search dropdown if clicking on an other input's button.
      if ($isDropdownInput) {
        $input.focus();
        // Fire a search if search field has text in it.
        if ($input.val()) {
          setTimeout(() => {
            $input.trigger("keyup");
          }, 0);
        }
      } else {
        $searchDropdown.slideUp(200);
        scrollToSearchInput($input, true);
      }
    });
  }

  /**
   * When window is resized manipulate menu as needed and
   * refresh search result window/ bubble.
   */
  function onWindowResize() {
    const windowWidth = $(window).width();

    if (windowWidth > 922) {
      $navPrimary.removeAttr("style");
      $html.removeClass("nav-open");
    } else if ($html.hasClass("nav-open")) {
      setMobileMenuHeight();
    }
    // Reset noDesktop slick slider
    if (windowWidth > 1080) {
      setTimeout(() => {
        $slickNoDesktop.slick("slickGoTo", 0);
      }, 600);
    }
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  const Kage = {
    // All pages
    common: {
      init() {
        // JavaScript to be fired on all pages
        const slick_settings = {
          arrows: true,
          dots: false,
          infinite: true,
          lazyLoad: "progressive",
          mobileFirst: true,
          slidesToShow: 4,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 300,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        };

        /**
         * This is used for sliders with exactly five items (on frontpage).
         * Hides slider functionality in desktop view.
         */
        const slick_settings_noDesktop = _.assign({}, slick_settings);
        slick_settings_noDesktop.responsive.unshift({
          breakpoint: 1080,
          settings: {
            accessibility: false,
            arrows: false,
            draggable: false,
            infinite: false,
          },
        });

        $(
          ".section-acf-products-carousel:not(.section-acf-products-carousel--noDesktop)",
        ).slick(slick_settings);

        $slickNoDesktop = $(
          ".section-acf-products-carousel.section-acf-products-carousel--noDesktop",
        ).slick(slick_settings_noDesktop);

        handleScroll();

        $(window).scroll(handleScroll);

        // Menu handling.
        const $navToggle = $(".nav-toggle");
        $navToggle.on("click", () => {
          setMobileMenuHeight();
        });

        $(window).resize(
          _.debounce(onWindowResize, 50, {
            maxWait: 200,
          }),
        );

        $(".section-acf-themes__content").slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          dots: false,
          lazyLoad: "progressive",
          mobileFirst: true,
          variableWidth: true,
          arrows: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 300,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
              },
            },
          ],
        });

        $(
          ".wp-block-kehittamo-block-tilaratkaisut-components-slider__content",
        ).slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false,
          lazyLoad: "progressive",
          mobileFirst: true,
          variableWidth: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 300,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ],
        });

        // NOTE: pardot script (https://pi.pardot.com/pd.js) expect global variable "piAId" to be preset (What?!)
        // Pardot Tracking code
        if (window.piAId !== undefined) {
          window.piAId = "32092";
        } else {
          window.piAId = "32092"; // eslint-disable-line
        }

        // NOTE: pardot script (https://pi.pardot.com/pd.js) expect global variable "piCId" to be preset (What?!)
        if (window.piCId !== undefined) {
          window.piCId = "1316";
        } else {
          window.piCId = "1316"; // eslint-disable-line
        }

        if (piHostname !== undefined) {
          piHostname = "pi.pardot.com";
        } else {
          var piHostname = "pi.pardot.com"; // eslint-disable-line
        }

        (function () {
          function async_load() {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = `${
              document.location.protocol == "https:"
                ? "https://pi"
                : "http://cdn"
            }.pardot.com/pd.js`;
            const c = document.getElementsByTagName("script")[0];
            c.parentNode.insertBefore(s, c);
          }
          if (window.attachEvent) {
            window.attachEvent("onload", async_load);
          } else {
            window.addEventListener("load", async_load, false);
          }
        })();

        // Kill link if menuitem have a innerelement -class

        jQuery(($) => {
          $("li.innerelement").children("a").attr("href", "javascript:void(0)");
        });
        jQuery(($) => {
          $("li.innerelement").children("a").attr("href", "javascript:void(0)");
        });

        // Initialize all search-related functionality.
        initSearch();

        // Wrangle Gutenberg buttons to have the link wrap the button,
        // instead of the link wrapping the button.
        const links = $(
          ".wp-block-kehittamo-block-tr-highlight .wp-block-button__link",
        );
        if (links) {
          links.each(function () {
            if ($(this).hasClass("wp-block-button__link--parallel")) {
              return;
            }
            const button = $(this).parent();
            const block = button.parent();
            $(this).detach();
            const html = $(this).html();
            $(this).html("");
            block.append($(this));
            $(this).append(button);
            button.html(html);
          });
        }

        // Hack gutenberg blocks where headings are followed by headings
        const headings = $(
          ".kehittamo-block-benedict > h1, .kehittamo-block-benedict > h2, .kehittamo-block-benedict > h3, .kehittamo-block-benedict > h4, .kehittamo-block-benedict > h5, .kehittamo-block-benedict > h6",
        );
        headings.each(function () {
          if (
            ["H1", "H2", "H3", "H4", "H5", "H6"].includes(
              $(this).parent().next().children().first().prop("tagName"),
            )
          ) {
            $(this).css("margin-bottom", 0);
            $(this).parent().next().children().first().css("margin-top", 0);
          }
        });

        /*
         * Filter structure block
         */
        const filterButton = $(".dropbtn");

        filterButton.on("click", function () {
          $(this).toggleClass("open");
          $(this).siblings(".dropdown-content").toggleClass("active");
        });

        /*
         * Dynamic nac
         */
        const dynamicNav = $(".wp-block-kehittamo-block-dynamic-nav").first();

        if (dynamicNav.length) {
          const header = $("header").first();
          dynamicNav.parent().detach().appendTo(header);
        }

        /*
         * Anchor menus
         */

        // Get all the anchors on the page.
        const anchors = $(".anchor");
        let showAnchor = true;

        if (anchors.length) {
          $(anchors).each((i, anchor) => {
            if ($(anchor).hasClass("anchor-menu-hidden")) {
              showAnchor = false;
            }
          });

          if (showAnchor) {
            // Create the menu.
            const anchorMenu = $("<div></div>");
            $(".wp-block-kehittamo-block-dynamic-nav").after(anchorMenu);
            anchorMenu.addClass("anchor-menu");

            // Add an ascending id number to the anchors.
            // eslint-disable-next-line func-names
            $.each(anchors, function (i) {
              $(this).attr("id", `anchor-${i}`);
            });

            // Create the menu items from the anchors.
            const anchorMenuItems = anchors
              .clone()
              .removeClass("anchor")
              .addClass("anchor-menu__item")

              // eslint-disable-next-line func-names
              .on("click", function () {
                // Scroll to the anchor with the identical id as the menu item.
                // Delete the menu item's id during this process, not to interfere.
                const id = $(this).attr("id");
                $(this).removeAttr("id");
                $([document.documentElement, document.body]).animate(
                  {
                    scrollTop: $(`#${id}`).offset().top - 180,
                  },
                  1500,
                );
                // Return the id.
                $(this).attr("id", id);
              });
            // // Add the menu items to the menu.
            anchorMenu.append(anchorMenuItems);
            $(".anchor-menu__item").wrapAll(
              "<div class='anchor-menu__wrapper' />",
            );
          }
        }

        /*
         * Single structure block
         */
        const imgSwitchButtons = $(".structure__setimg");
        if (imgSwitchButtons) {
          imgSwitchButtons.on("click", function (event) {
            const parent = $(this).closest($(".structure__images"));
            if ($(this, parent).hasClass("active")) {
              return;
            }
            $(".structure__setimg", parent).toggleClass("active");
            const images = $(".structure__image", parent);
            images.toggleClass("active");
          });
        }

        // Handle structure modal.
        const structureModal = $(".structure__modal");
        if (structureModal) {
          // There might be multiple blocks of this type so use a context.
          function toggleModal(ctx) {
            $(".structure__fullscreen").toggleClass("active");
            ctx.toggleClass("active");
            const images = $(".structure__images-display", ctx);
            images.toggleClass("active");
          }
          // Close all possible versions of the modal.
          function removeModal() {
            $(".structure__fullscreen").toggleClass("active");
            $(".structure__modal").removeClass("active");
            $(".structure__images-display").removeClass("active");
          }
          const modalToggleButton = $(".structure__fullscreen");
          // Toggle the modal on the fullscreen icon click.
          modalToggleButton.on("click", function (event) {
            const parent = $(this).closest(".structure__modal");
            toggleModal(parent);
          });
          // Close the modal when hitting esc.
          $(document).keyup((e) => {
            if (e.key === "Escape" && structureModal.hasClass("active")) {
              removeModal();
            }
          });
          // Listen for click events on the whole window when the modal is open.
          $(window).click(() => {
            if (structureModal.hasClass("active")) {
              removeModal();
            }
          });
          // But stop propagating them if the were clicks in the modal content.
          $(".structure__modal-content").click((event) => {
            event.stopPropagation();
          });
        }
      },
      finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init() {},
      finalize() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init() {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire(func, funcname, args) {
      let fire;
      const namespace = Kage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        (i, classnm) => {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        },
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
